import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Suggestion } from 'src/app/public/socio-emotional-skills-test/socio-emotional-skills-test.models';
import { SocioEmotionalSkillsTestResultsSuggestionsCompleteFormComponent } from '../socio-emotional-skills-test-results-suggestions-complete-form/socio-emotional-skills-test-results-suggestions-complete-form.component';

@Component({
  selector: 'app-socio-emotional-skills-test-results-suggestions-card',
  templateUrl: './socio-emotional-skills-test-results-suggestions-card.component.html',
  styleUrls: ['./socio-emotional-skills-test-results-suggestions-card.component.scss']
})
export class SocioEmotionalSkillsTestResultsSuggestionsCardComponent implements OnInit {
  @Input() suggestion: Suggestion;
  @Input() skillName: string;

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openSuggestionCompletedModal(): void {

    const dialogRef = this.dialog.open(SocioEmotionalSkillsTestResultsSuggestionsCompleteFormComponent, {
      width: '650px',
      data: { suggestion: this.suggestion }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.suggestion.completed = true;
      }
    });

  }


}
